module.exports = __webpack_public_path__ + "img/988918324ec22729b11b268b754b2a82.470b2ebb.png";